export interface User {
    Id: number;
    FullName: string;
    Person: string;
    Active: boolean;
    Address: string;
    Email: string;
    Phone: string;
    City: string;
    Region: string;
    Zip: string;
    Role: string;
    LoginName: string;
    WorkPhone: string | null;
    Cell: string;
    Leadership: boolean;
    Department: string;
    PersonalEmail: string;
    DontText: number;
    DontEmail: number;
    Supervisor: string | null;
    DateHired: string;
    AnalystLevel: string;
    EmpStatus: string;
    SPID: number;
    State: string;
    PBSLiveExtension: string;
    HoursRequiredperWeek: number;
    RegionID: number;
}

export interface UserProfileProperties {
    [key: string]: string;

    // Identity
    UserProfile_GUID: string;
    UserName: string;
    AccountName: string;
    PreferredName: string;
    FirstName: string;
    LastName: string;
    Title: string;
    PictureURL: string;
    WorkEmail: string;
    PersonalEmail: string;
    Manager: string;
    PreferredDisplayName: string;

    // Contact
    CellPhone: string;
    EmergencyContactName: string;
    EmergencyContactNumber: string;

    // Address
    Streetaddress: string;
    City: string;
    State: string;
    Zip: string;
    County: string;
    CountyofResidence: string;

    // Personal
    BirthDate: string;
    Gender: string;
    Stateofbirth: string;
    CityOfBirth: string;
    Languagesspoken: string;
    "Race-Ethnicity": string;

    // Employment
    HireDate: string;
    Department: string;
    RegionalCoordinator: string;
    AboutMe: string;
    ABAHoursAvailable: string;
    SaturdayAvailability: string;
    SundayAvailability: string;
    CurrentTaxReportingName: string;
    UseSSNForReporting: string;
    UseCurrentAddressForReporting: string;
    SameMailingAndHomeAddress: string;
    AddSecondaryAccountDetails: string;
    DepositBonus: string;
    CAQHReattest: string;
    Resumelink: string;
}

export interface UserProfileResponse {
    userId: string;
    properties: UserProfileProperties;
    profileFound: boolean;
    errorMessage: string | null;
}

export const initialUserValues: User = {
    Id: 0,
    FullName: '',
    Person: '',
    Active: false,
    Address: '',
    Email: '',
    Phone: '',
    City: '',
    Region: '',
    Zip: '',
    Role: '',
    LoginName: '',
    WorkPhone: null,
    Cell: '',
    Leadership: false,
    Department: '',
    PersonalEmail: '',
    DontText: 0,
    DontEmail: 0,
    Supervisor: null,
    DateHired: '',
    AnalystLevel: '',
    EmpStatus: '',
    SPID: 0,
    State: '',
    PBSLiveExtension: '',
    HoursRequiredperWeek: 0,
    RegionID: 0,
}